import { combineReducers } from "redux";
import authReducer from "./authReducers";
import errorReducer from "./errorReducers";
import selectionReducer from "./selectionReducers";
export default combineReducers({
  auth: authReducer,
  errors: errorReducer,
  selection: selectionReducer,
});
